import { useEffect, useState } from 'react'
import { useInitGuestAccount } from '~/services/auth-service'

export function useAuth() {
  const [accessToken, setAccessToken] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [shouldGenerateGuest, setShouldGenerateGuest] = useState(false)

  const {
    mutate: initGuestAccount,
    isSuccess: isGuestAccountSuccess,
    isPending: isGeneratingGuest,
    isError: isGuestAccountError,
  } = useInitGuestAccount()

  useEffect(() => {
    const getAccessToken = async () => {
      try {
        const token = localStorage.getItem('access_token')

        if (token) {
          setAccessToken(token)
          setShouldGenerateGuest(false)
        } else {
          // No token found, need to generate guest account
          setShouldGenerateGuest(true)
        }
      } catch (error) {
        console.error('Error getting access token:', error)
        setShouldGenerateGuest(true)
      } finally {
        setIsLoading(false)
      }
    }
    getAccessToken()
  }, [])

  // Generate guest account when needed
  useEffect(() => {
    // if (shouldGenerateGuest && !isGeneratingGuest && !isGuestAccountSuccess) {
    //   initGuestAccount()
    // }
    if (shouldGenerateGuest) {
      initGuestAccount()
    }
    // }, [shouldGenerateGuest, isGeneratingGuest, isGuestAccountSuccess, initGuestAccount])
  }, [shouldGenerateGuest, initGuestAccount])

  // Update access token when guest account is successfully created
  useEffect(() => {
    if (isGuestAccountSuccess) {
      const updateToken = async () => {
        try {
          const token = localStorage.getItem('access_token')
          if (token) {
            setAccessToken(token)
            setShouldGenerateGuest(false)
          }
        } catch (error) {
          console.error('Error updating access token:', error)
        }
      }
      updateToken()
    }
  }, [isGuestAccountSuccess])

  return { accessToken, isLoading: isLoading || isGeneratingGuest, isGuestAccountError }
}
